<template>
  <div id="indexTwo">
    <div class="waring-head" @click="hqGo">
      <a href="javascript:void(0)" v-for="items in hq.live.tips" v-if="items.State == 0">{{items.Content}} ></a>
    </div>
    <div class="warning-main" id="markquee" v-for="items in hq.live.tips" v-if="items.State == 1">
      <div class="sqBorder">
        <!--#####滚动区域#####-->
        <div id="scroll_div" class="scroll_div">
          <div id="scroll_begin">
            <ul>
              <li>
                {{items.Content}}
              </li>
            </ul>
          </div>
          <div id="scroll_end"></div>
        </div>
        </div>
    </div>
    <!-- 转入活期宝 begin -->
    <div class="content-main">
      <div class="main-title">
        <div class="main-title-desc">可提现收益: <span class="can-use-tx">{{hq.live.availableluckymoney}}</span>浪票 (税前)</div>
        <!--<div class="main-title-set" @click="setting">设置</div>-->
      </div>
      <div class="able-lang-piao">
        <div class="can-transfer">
          <div>{{hq.live.availablecash}}</div>
          <div class="price-dw">元</div>
        </div>
        <!--<div class="can-transfer-btn-cont">
          <div class="btn-comm" @click="overTo(hq.live.availablecash, hq.live.rate)">转入活期宝</div>
        </div>-->
      </div>
      <!--<div class="can-price">({{hq.live.availablecash}}元)</div>-->
      <div class="tx-content">
        <div class="sui-money">
          <div class="sui-money-jiao sui-money-jiao-right">
            <div class="sui-money-desc">待结算现金收益</div>
            <div class="sui-money-comm"><span class="sui-money-p">{{hq.live.frozencash}}</span><span class="sy-dw">元</span></div>
          </div>
          <div class="sui-money-jiao sui-money-jiao-left">
            <div class="sui-money-desc">累计现金收益</div>
            <div class="sui-money-comm"><span class="sui-money-p">{{hq.live.cashamount}}</span><span class="sy-dw">元</span>
            </div>
          </div>
        </div>
        <!--<div class="btn-main">
          <div @click="spray()" class="langhua-jl tx-btn-comm">浪票收支记录</div>
          <img class="icon-help" src="../../assets/images/icon_help.png">
          <div class="langhua-hqb tx-btn-comm"><a href="http://lvbsns.eastmoney.com/LVBPages/Static/DiamondsHelp.html">结算浪票帮助</a>
          </div>
        </div>-->
      </div>
    </div>
    <!-- 转入活期宝 end   -->
    <div class="content-main hqpord hq-tx-cont">
      <div class="hq-tx-main" @click="hqporddetail()">
        <div class="hq-tx-desc"> <img src="../../assets/images/sy-detail.png" class="lc-icon">收益明细</div>
        <div class="right-main">
          <i class="mui-icon mui-icon-arrowright right-icon"></i>
        </div>
      </div>
    </div>
    <div class="content-main hqpord hq-tx-cont" @click="financial()">
      <div class="hq-tx-main">

        <div class="hq-tx-desc"><img src="../../assets/images/lc-icon-t.png" class="lc-icon">基金理财</div>
        <div class="right-main">

          <span class="lc-desc">赚钱更轻松</span>
          <i class="mui-icon mui-icon-arrowright right-icon"></i>
        </div>
      </div>
    </div>
    <!--<div class="footer">
      <div class="footer-help">
        <div class="btn-main-h">
          <a v-if="isIos" href="tel:021-24099034" class="txt-comm tell" @click='sendMobile'>客服电话: 021-24099034</a>
          <a v-if="!isIos && androidDisplay" href="tel:021-24099034" class="txt-comm tell" @click='sendMobile'>客服电话: 021-24099034</a>
          <a v-if="!isIos && !androidDisplay" href="javascript:void(0)" class="txt-comm">客服电话: 021-24099034</a>
        </div>
        <div class="word-day">工作日：9:00&#45;&#45;18:00</div>
      </div>
    </div>-->
    <div id="bottom-menu">
      <div class="tiper" @click="hqpordHelp()">
        收益结算及提现规则
      </div>
      <div class="menu-container">
        <div class="menu-main" @click="showCash()">
          我的活期宝
        </div>
        <div class="menu-main" @click="overTo()">
          提现
        </div>
      </div>
    </div>
    <!-- form 表单提交 判断是否通过基金平台开户 begin-->
    <form action="/LKHqb/CheckFundUserStatus" method="post" id="fundForm" style="display: none">
      <input type="text" name="device_id" v-model='deviceId' placeholder="">
      <input type="text" name="ctoken" v-model='ctoken' placeholder="">
      <input type="text" name="utoken" v-model='utoken' placeholder="">
      <input type="text" name="targetUrl" v-model='targetUrl' placeholder="">
      <input type="text" name="type" v-model="targetType" placeholder=""/>
    </form>
    <!-- form 表单提交 判断是否通过基金平台开户 end  -->
  </div>
</template>
<style lang="less" scoped src="../../assets/less/hqpordindex.less"></style>
<script>
  import {mapGetters} from 'vuex'
  import {SET_TITLE, emH5TopBtnNeed} from '../../utils/emapp'
  import {IS_IOS} from '../../utils/useragent'
  import {session} from '../../utils/storage'
  import cookie from '../../utils/cookie'

  export default {
    computed: mapGetters({
      hq: 'initHqpordIndex'
    }),
    data () {
      return {
        deviceId: cookie('device_id'),
        ctoken: cookie('ctoken'),
        utoken: cookie('utoken'),
        targetUrl: '',
        targetType: '', // 0(转入活期宝) 1（我的活期宝） 2（天天基金）
        isIos: true,
        androidDisplay: false,
        redCount: 0,     // 判断红包
        isShowHasfundaccount: false,
        isJb: true,
        targetVersioin: '1.8.0'    // 目标版本
      }
    },
    mounted: function () {
      var _this = this
      setTimeout(function () {
        SET_TITLE('我的收益')
      }, 100)

      // 这是一个全局的函数，所以的返回逻辑都在这里判断
      // 右上角功能按钮回调
      window.callbackTopBtn = function () {
        _this.$router.push({path: '/help/process'})
      }
      window.goBack = function () {
        if (_this.$route.path === '/hqpord/index') {
          if (IS_IOS) {
            console.log('close:true')
            window.location = 'emH5Close:' // ios
          } else {
            console.log('close:true')
            window.eastmoney.emH5Close() // android
          }
        } else {
          if (IS_IOS) {
            window.history.back()
          }
        }
      }
      session.removeItem('withdrawcard')
      this.isIos = IS_IOS
      if (cookie('version') > '1.4.0') {
        this.androidDisplay = true
      }
      console.log(this.androidDisplay)
      this.$store.dispatch('getLiveAccounts', {_this: this})
      // 获取红包信息
      // this.$store.dispatch('getRedInfor', {_this: this})
    },
    methods: {
      // 查看活期宝余额
      look (isShow, event) {
        this.$store.dispatch('changeLook', {isShow: isShow, event: event})
      },
      // 转入活期宝
      overTo (total, rate) {
        this.targetUrl = window.location.pathname + '#/hqpord/into'
        this.targetType = 0
        if (this.updateSystem().companyState !== 2 && this.compareVersion()) {
          setTimeout(function () {
            $('#fundForm').submit()
          }, 500)
        }
      },
      // 浪花收支记录
      spray () {
        this.$router.push({path: '/profit/list'})
      },
      // 收益明细
      hqporddetail () {
        this.$router.push({path: `/hqpord/detail/${this.hq.live.cashamount}`})
      },
      showCash (event) {
        this.targetUrl = ''
        this.targetType = 1
        if (this.compareVersion()) {
          setTimeout(function () {
            $('#fundForm').submit()
          }, 500)
        }
       // this.$router.push({path: '/hqpord/tcash'})
      },
      financial () {
        this.targetUrl = ''
        this.targetType = 2
        if (this.compareVersion()) {
          setTimeout(function () {
            $('#fundForm').submit()
          }, 500)
        }
      },
      // 提现
      cash () {
        this.$router.push({path: '/action/index'})
      },
      hqGo () {
        this.$router.push({path: '/tips/upgrade'})
      },
      // 打电话
      sendMobile (event) {
        let time = 5
        let count = setInterval(function () {
          if (time > 1) {
            time--
            $('.tell').attr('href', 'javascript:void(0)')
            console.log(this.telphone)
          } else {
            time = 3
            $('.tell').attr('href', 'tel:021-24099034')
            clearInterval(count)
          }
        }, 1000)
      },
      // 设置
      setting () {
        this.$router.push({path: '/hqpord/setting', query: {'limitAmount': this.hq.live.limitAmount}})
      },
      // 我的红包
      openRed () {
        this.$router.push({path: '/packet/red', query: {availableluckymoney: this.hq.live.availableluckymoney, isidcaradimg: this.hq.live.isidcaradimg, returl: this.hq.live.backurl}})
      },
      // 版本判断 以及 是否实名认证了
      compareVersion () {
        if (cookie('version') > this.targetVersioin) {
          if (!this.hq.hasverified) {
            window.location.href = this.hq.live.userauthpage + '/frontend/authentication/#user/auth?back_url=' + encodeURIComponent(window.location.origin + '/hqb/withdraw/#/hqpord/index')
            return false
          }
          return true
        } else {
          mui.alert('版本更新,请升级', function () {
            window.location.href = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.eastmoney.haitunlive'
          })
          return false
        }
      },
      // 系统升级停机判断
      updateSystem () {
        var _this = this
        var noticeState = {
          companyState: 0,  // 2(公司系统升级)
          bankState: 0  // 1(银行系统升级)
        }
        for (var i = 0; i < _this.hq.live.tips.length; i++) {
          if (_this.hq.live.tips[i].State === 2) {
            noticeState.companyState = 2
            mui.alert(_this.hq.live.tips[i].Content)
          } else if (_this.hq.live.tips[i].State === 1) {
            noticeState.bankState = 1
          }
        }
        return noticeState
      },
      hqpordHelp () {
        // 测试环境 https://list-qas.lvb.eastmoney.com/
        window.location.href = 'https://list.lvb.eastmoney.com/LVBPages/Static/DiamondsHelp.html'
      },
      ScrollImgLeft () {
        var speed = 20
        var scrollbegin = document.getElementById('scroll_begin')
        var scrollend = document.getElementById('scroll_end')
        var scrolldiv = document.getElementById('scroll_div')
        scrollend.innerHTML = scrollbegin.innerHTML
        function Marquee () {
          if (scrollend.offsetWidth - scrolldiv.scrollLeft <= 0) {
            scrolldiv.scrollLeft -= scrollbegin.offsetWidth
          } else {
            scrolldiv.scrollLeft++
          }
        }
        var MyMar = setInterval(Marquee, speed)
        scrolldiv.addEventListener('touchstart', function () {
          clearInterval(MyMar)
        })
        scrolldiv.addEventListener('touchend', function () {
          MyMar = setInterval(Marquee, speed)
        })
      }
    },
    filters: {
      // 截取余额小数点
      rounding: function (value) {
        if (!isNaN(value)) {
          let str = value.toString()
          let sum = str.split('.').length
          if (sum > 1) {
            if (str.split('.')[1].length > 1) {
              return value.toFixed(2)
            }
            return `${value}0`
          }
          return `${value}.00`
        }
      }
    },
    beforeRouteEnter (to, from, next) {
      next(vm => {
        emH5TopBtnNeed(2, '', require('../../assets/images/help_btn.png'), 'callbackTopBtn')
      })
      // SET_TITLE('我的收益')
      // next()
    },
    beforeRouteLeave (to, from, next) {
      // 设置下一个路由的meta
      to.meta.keepAlive = false
      next()
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?70a22efd